import type { LibItemSysIcon } from '@types';

export const sandtableGroupIconList: LibItemSysIcon[] = [
  { url: '/sandtable/group/1.76b4bee71de30989bf277d355ddb6d95.svg', frame: 1 },
  { url: '/sandtable/group/2.7fa1cc795afe205d8e2d9c345c9229d5.svg', frame: 1 },
  { url: '/sandtable/group/3.7c88cef0791a184ef10091e068a1b775.svg', frame: 1 },
  { url: '/sandtable/group/4.6fc9e843b020a3b2ba68014e3f9a0c4e.svg', frame: 1 },
  { url: '/sandtable/group/5.080141907d113cfc10a16d84f897c8a2.svg', frame: 1 },
  { url: '/sandtable/group/6.fa22a8702902bb1e91d12593802bb1db.svg', frame: 1 },
  { url: '/sandtable/group/7.ab75594b6414e83975aa72018b5287a8.svg', frame: 1 },
  { url: '/sandtable/group/8.2eb5c1ba395125d2b9f26e71b6be5d49.svg', frame: 1 },
  { url: '/sandtable/group/9.5774f6d59112329836001d118cf87589.svg', frame: 1 },
  { url: '/sandtable/group/10.e0e0ead2fde2bbb70125c0efc0834aea.svg', frame: 1 },
  { url: '/sandtable/group/11.e53832747d436dcbf23297c4692765a5.svg', frame: 1 },
  { url: '/sandtable/group/12.a2356b12172db7399591c34a18954d68.svg', frame: 1 },
  { url: '/sandtable/group/13.e8aebb9cd1b222197988c93cab273f81.svg', frame: 1 },
  { url: '/sandtable/group/14.beb49cc37b43f7bbeeca37bd339efb92.svg', frame: 1 },
  { url: '/sandtable/group/15.d51ed5307262eaf4d3470a7fb83804c4.svg', frame: 1 },
  { url: '/sandtable/group/16.e9a90dd64d34eac876b1e1386eb36b90.svg', frame: 1 },
  { url: '/sandtable/group/17.30fef1bc95aa69035b8b94f914a4a6c2.svg', frame: 1 },
  { url: '/sandtable/group/18.7a8082828b55994db45157b2a75f6b30.svg', frame: 1 },
  { url: '/sandtable/group/19.450e4568bac21a85f3e37cbb24220ea0.svg', frame: 1 },
  { url: '/sandtable/group/20.2cec263703e6197c46f4389d84681958.svg', frame: 1 },
  { url: '/sandtable/group/21.d9ab3262c2e34417b16ae2a5b7318d71.svg', frame: 1 },
  { url: '/sandtable/group/22.1546addffb76d7dc7a570d2c9d6a8db7.svg', frame: 1 },
  { url: '/sandtable/group/23.13d77e1a23e21fba958f24d2cfedadfe.svg', frame: 1 },
  { url: '/sandtable/group/24.4cd812081469d486e74cae0f7010e4a9.svg', frame: 1 },
  { url: '/sandtable/group/25.9df59b9172eabfb7965c72be645d972b.svg', frame: 1 },
  { url: '/sandtable/group/26.218d019f5b779d467bcf9da3197b67c8.svg', frame: 1 },
  { url: '/sandtable/group/27.9128f5d3438e2cf13cc2a4020ad93164.svg', frame: 1 },
  { url: '/sandtable/group/28.5e3c151216ba7c1fe3b6abf258684bb6.svg', frame: 1 },
  { url: '/sandtable/group/29.7408fbbba20dd0da3808888803f494e8.svg', frame: 1 },
  { url: '/sandtable/group/30.dcdd682934e1958472b15034f4b87d57.svg', frame: 1 },
  { url: '/sandtable/group/31.7fa368f7df9b15b5105cad1cf2a6314d.svg', frame: 1 },
  { url: '/sandtable/group/32.f9614ed1c1670e781977962a192266a3.svg', frame: 1 },
  { url: '/sandtable/group/33.0c1b2cb986c142bca85792625cc05453.svg', frame: 1 },
  { url: '/sandtable/group/34.6c17ec3cdc7fae5cbf0e808080c43a05.svg', frame: 1 },
  { url: '/sandtable/group/35.779d81cabd2fed32d44389df9e04a86e.svg', frame: 1 },
  { url: '/sandtable/group/36.d57008a0c704a1db235b2e3260d915c9.svg', frame: 1 },
  { url: '/sandtable/group/37.c1ee2f1435189fa833cafa4b1fec8bc2.svg', frame: 1 },
  { url: '/sandtable/group/38.12f10d0e35e358bb9c6602eb12eccfe5.svg', frame: 1 },
  { url: '/sandtable/group/39.9a4d2a0eb2ba2ce4e5ef6bb230861a99.svg', frame: 1 },
  { url: '/sandtable/group/40.ce54a9e4fcca90f6dd73e1ca364ee6da.svg', frame: 1 },
  { url: '/sandtable/group/41.3e0f0f97029861e94cbdc8be80d208a6.svg', frame: 1 },
  { url: '/sandtable/group/42.c254416bf825dcb447bd90a01f2bb861.svg', frame: 1 },
  { url: '/sandtable/group/43.63f913683d2747632c5d7b7114c3fabf.svg', frame: 1 },
  { url: '/sandtable/group/44.2f13a101a09733dac1c5c8cd0b123be9.svg', frame: 1 },
  { url: '/sandtable/group/45.bce0335fcb5bf0275620729cd0c8ae52.svg', frame: 1 },
  { url: '/sandtable/group/46.9cbc26d92aecbd73b2e4813b33e55c04.svg', frame: 1 },
  { url: '/sandtable/group/47.f4cdceeb3376b2dd7d753386e74fc052.svg', frame: 1 },
  { url: '/sandtable/group/48.e79c8c4c216928684ac9383358d20fe9.svg', frame: 1 },
  { url: '/sandtable/group/49.bc9b9986ec07f1ae3337072ee6473f06.svg', frame: 1 },
  { url: '/sandtable/group/50.2e9625e16c4ca331af0069276fc5465b.svg', frame: 1 },
  { url: '/sandtable/group/51.9332dd422df19da0ed78681d4d869972.svg', frame: 1 },
  { url: '/sandtable/group/52.5577ac205c24702f5056c928f1f62222.svg', frame: 1 },
  { url: '/sandtable/group/53.694f09c9dff7b39fa39acf3ca7962994.svg', frame: 1 },
  { url: '/sandtable/group/54.036d8228dc78f1467afd561ef0961641.svg', frame: 1 },
  { url: '/sandtable/group/55.6fc1039c66b83c5817981006ef0fbe27.svg', frame: 1 },
  { url: '/sandtable/group/56.32f1bd350764d752c4fed0e33ab4d54a.svg', frame: 1 },
  { url: '/sandtable/group/57.c41dbbcc8715fa28b742a0c23dca79d4.svg', frame: 1 },
  { url: '/sandtable/group/58.5073ae114bfc9f5a290645fdb7c922bd.svg', frame: 1 },
  { url: '/sandtable/group/59.f06cb5900b0a1ca6a3486e4b89fea394.svg', frame: 1 },
  { url: '/sandtable/group/60.fac02ddcc0ff96fb612f44b1adbf9610.svg', frame: 1 },
  { url: '/sandtable/group/61.513c97464f432464ca0ff5567e9f5b63.svg', frame: 1 },
  { url: '/sandtable/group/62.ece3291c0af5247f0a3373e31c9cdf06.svg', frame: 1 },
  { url: '/sandtable/group/63.4c8b426f5d1d7db319ef6759f233f630.svg', frame: 1 },
];
